import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, inject, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { faLaptopBinary } from '@fortawesome/pro-regular-svg-icons';

import { ProgrammerNotesDialogComponent } from './programmer-notes-dialog/programmer-notes-dialog.component';
import { SurveyEditorService } from '../../services/survey-editor.service';

@Component({
  selector: 'empathy-programmer-notes',
  templateUrl: 'programmer-notes.component.html',
  styleUrls: ['./programmer-notes.component.scss'],
  animations: [
    trigger('grow', [
      state(
        'true',
        style({
          padding: '16px 32px 16px 32px',
          height: '*'
        })
      ),
      state(
        'false',
        style({
          padding: '0 32px 0 32px',
          height: '40px'
        })
      ),
      transition('true => false', animate('400ms ease-in-out')),
      transition('false => true', animate('400ms ease-in-out'))
    ])
  ]
})
export class ProgrammerNotesComponent {
  @Input() programmerNotes: string;

  dialog = inject(MatDialog);
  surveyEditorService = inject(SurveyEditorService);
  faLaptopBinary = faLaptopBinary;

  onOpen(): void {
    this.dialog.open(ProgrammerNotesDialogComponent, { data: { programmerNotes: this.programmerNotes } });
  }
}
